import {
  CursorResult,
  Space,
  SpacePostEmbeds,
  TimelineItem,
  getSpacePosts,
} from '@kudos/http-client'
import { SpacePermissions, hasPermission } from '@shared/permissions'
import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query'
import { isEmpty } from 'lodash'
import { useEffect } from 'react'

export const spaceListPostEmbeds: SpacePostEmbeds[] = [
  'author',
  'media',
  'reactionCounts',
  'comments',
  'albumWithPreviewPhotos',
]
export const SPACE_POSTS_TIMELINE_QK = 'spacesPostTimelineQueryKey'
const useSpaceTimelineItems = (space?: Space) => {
  const infiniteQueryKey = [SPACE_POSTS_TIMELINE_QK]
  const queryClient = useQueryClient()
  const canCreatePost = !!space && hasPermission(space, SpacePermissions.CreatePost)
  const resetInfiniteQueryPagination = (): void => {
    queryClient.setQueryData(
      infiniteQueryKey,
      (oldData: {
        pageParams: { pageParam: null | string }[]
        pages: CursorResult<TimelineItem>[]
      }) => {
        if (!oldData) return undefined

        return {
          pages: oldData.pages.slice(0, 1),
          pageParams: oldData.pageParams.slice(0, 1),
        }
      },
    )
  }

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isFetching } =
    useInfiniteQuery({
      queryKey: infiniteQueryKey,
      queryFn: ({ pageParam = null }: { pageParam: null | string }) =>
        getSpacePosts(space?.id ?? '', {
          cursor: pageParam,
          embeds: spaceListPostEmbeds,
        }),
      getNextPageParam: lastPage => lastPage.next,
      initialPageParam: null,
      enabled: !isEmpty(space),
    })

  useEffect(() => {
    resetInfiniteQueryPagination()
    // NOTE: SYN-6793 Ignore all exhaustive-deps warnings. Devs should try to fix (and test) when page is revisited
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    timelineData: data,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    isLoading: isLoading || isFetching,
    canCreatePost,
  }
}

export default useSpaceTimelineItems
